import { LoginRequest, LoginResponse } from 'src/models/login';
import axiosInt from 'src/utils/axios';
import { userManagementAPIRoutes } from '..';

/**
 * Sends a login request to the user management API.
 *
 * @param {LoginRequest} loginRequest - The login request object containing the user's credentials.
 * @returns {Promise<LoginResponse>} - A promise that resolves to the response from the login API.
 */
export const loginService = async (loginRequest: LoginRequest) => {
  return axiosInt.post<LoginResponse>(
    `${userManagementAPIRoutes.baseUrl}/${userManagementAPIRoutes.login.endpoint}`,
    loginRequest
  );
};

export const logoutService = async () => {
  return axiosInt.get(
    `${userManagementAPIRoutes.baseUrl}/${userManagementAPIRoutes.logout.endpoint}`
  );
};
